import React from 'react'
import AdminDashboard from './AdminDashboard'
import BoatOwnerDashboard from './BoatOwnerDashboard'
import CaptainDashboard from './CaptainDashboard'
import ShopDashboard from './ShopDashboard'
import PortDashboard from './PortDashboard'

class Dashboard extends React.Component {
  render() {
    return localStorage.getItem('loged_In_role') === 'port-admin' ? (
      <PortDashboard />
    ) : localStorage.getItem('loged_In_role') === 'admin' ? (
      <AdminDashboard />
    ) : localStorage.getItem('loged_In_role') === 'shop' ? (
      <ShopDashboard />
    ) : localStorage.getItem('loged_In_role') === 'boatOwner' ? (
      <BoatOwnerDashboard />
    ) : (
      <CaptainDashboard />
    )
  }
}

export default Dashboard
